import RegionRepository from '../../../networking/repos/RegionRepository';
import {useQueryConfig} from '../Utils';
import {RegionQueryKey} from './Key';

export const useRegionIndexQueryConfig = () => {
    const repo = new RegionRepository();

    return useQueryConfig(RegionQueryKey.index, () => repo.all());
};
